/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import {
    CashBoxStatusesHistoryDto,
    CashBoxStatusesHistoryQueryParams,
} from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';

export enum CashBoxStatusTabActionType {
    EXIT_CASHBOX_STATUS_TAB = 'CashBoxStatusTab/ exit tab',
    FETCH_CASHBOX_STATUS_HISTORY = 'CashBoxStatusTab/ fetch status history start',
    FETCH_CASHBOX_STATUS_HISTORY_SUCCESS = 'CashBoxStatusTab/ fetch status history success',
    FETCH_CASHBOX_STATUS_HISTORY_ERROR = 'CashBoxStatusTab/ fetch status history error',
    DOWNLOAD_STATUS_HISTORY = 'CashBoxStatusTab/ download status history as excel start',
    DOWNLOAD_STATUS_HISTORY_SUCCESS = 'CashBoxStatusTab/ download status history as excel success',
    DOWNLOAD_STATUS_HISTORY_ERROR = 'CashBoxStatusTab/ download status history as excel error',
}

export const exitCashBoxStatusTabAction = () => createAction(CashBoxStatusTabActionType.EXIT_CASHBOX_STATUS_TAB);

export const fetchCashBoxStatusHistoryAction = (taxNumber: string, params: CashBoxStatusesHistoryQueryParams) =>
    createAction(CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY, { taxNumber, params });

export const fetchCashBoxStatusHistorySuccessAction = (payload: CashBoxStatusesHistoryDto) =>
    createAction(CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY_SUCCESS, payload);

export const fetchCashBoxStatusHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY_ERROR, { notification });

export const downloadStatusHistoryAction = (taxNumber: string) =>
    createAction(CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY, taxNumber);

export const downloadStatusHistorySuccessAction = () =>
    createAction(CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY_SUCCESS);

export const downloadStatusHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY_ERROR, { notification });

export type CashBoxStatusTabAction =
    | ReturnType<typeof exitCashBoxStatusTabAction>
    | ReturnType<typeof fetchCashBoxStatusHistoryAction>
    | ReturnType<typeof fetchCashBoxStatusHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxStatusHistoryErrorAction>
    | ReturnType<typeof downloadStatusHistoryAction>
    | ReturnType<typeof downloadStatusHistorySuccessAction>
    | ReturnType<typeof downloadStatusHistoryErrorAction>;
